import { Base } from './_base.model';

export class QuestionTooltip extends Base {
  id: string;
  label: string;
  content: string;
  created_at: Date;
  updated_at: Date;
}
